// Shared layout anchors. The embed views used to subtract hand-tuned constants
// (135, 72, 66) that all encoded the navbar height, so changing the navbar
// silently broke each of them. They take the full viewport now and scroll the
// navbar out of the way instead.
const NAVBAR_ID = "main-navbar";
const CONTENT_ID = "page-content";

// Puts the routed content flush against the top of the viewport, scrolling the
// navbar out of the way so a game or an embed fills the screen exactly.
const scrollToContent = () => {
  const content = document.getElementById(CONTENT_ID);
  if (content) {
    content.scrollIntoView({ behavior: "smooth", block: "start" });
  }
};

// Overlay buttons ("Back Home", "Select a new Resource") float above the
// content rather than sitting in the flow. They were each hardcoded to top:100,
// tuned against a taller navbar, and two of them landed on identical
// coordinates on the same screen. Row 0 is the button that goes one level up;
// row 1 is the second button when a page shows two.
const OVERLAY_TOP = 56;
const OVERLAY_LEFT = 7;
const OVERLAY_ROW_HEIGHT = 44;

const overlayButtonStyle = (row = 0) => ({
  position: "absolute",
  top: OVERLAY_TOP + row * OVERLAY_ROW_HEIGHT,
  left: OVERLAY_LEFT,
  zIndex: 10,
});

export {
  NAVBAR_ID,
  CONTENT_ID,
  OVERLAY_TOP,
  scrollToContent,
  overlayButtonStyle,
};
